import React from "react";
import Home from "./components/homepage/Home";
import './app.scss';

function App() {
  return (
    <Home />
  );
}

export default App;
